import { IPositionHelpSteps, ITypeTypesHelpSteps, IStepHelpSteps } from 'app_types/components/helpSteps/helpStepsTypes';
import React, { Component, CSSProperties } from 'react';
import { Styles, Step, CallBackProps } from 'react-joyride'
import {TooltipRenderProps} from 'react-joyride'

import { HelpStepsLayout } from './../index'
import storeService from 'app_services/storeService'

interface IHelpStepsComponentProps {
  steps: IStepHelpSteps[]
  styleJoyride?: Styles
  className?: string
  style?: CSSProperties
  continuous?: boolean
  showProgress?: boolean
  disableOverlayClose?: boolean
  showSkipButton?: boolean
  position?: IPositionHelpSteps    // Posición en la pantalla, debe estar el prop fixed=true
  type?: ITypeTypesHelpSteps  // Estilos por defecto para el componente por defecto 'floating'
  fixed?: boolean   // Si se establece en true se puede utilizar el prop 'position' con cualquier 'type'
  tooltipComponent?: React.ElementType<TooltipRenderProps>
  onUpdate?:(data?: CallBackProps)=> void
  onNext?:(data?: CallBackProps)=> void
  onReset?:(data?: CallBackProps)=> void
  onClose?:(data?: CallBackProps)=> void
  onPrev?:(data?: CallBackProps)=> void
}

interface IHelpStepsComponentState {
  forceOpen?: boolean
}

class HelpStepsComponent extends Component<IHelpStepsComponentProps, IHelpStepsComponentState> {
  constructor(props: IHelpStepsComponentProps) {
    super(props)
    this.state = {
      forceOpen: false
    }
  }
  componentDidMount(): void {
    storeService?.subscribe('app.helpSteps', this.handleHelpStepsChange)
  }
  handleHelpStepsChange = (data: any) => {
    if (data) {
      this.setState({forceOpen: data.open})
    }
  }
  render() {
    return (
      <HelpStepsLayout
        {...this.props}
        forceOpen={this.state.forceOpen}
      />
    );
  }
}

export default HelpStepsComponent;
